<template>
  <div class="modal is-visible">
    <div class="modal-wrapper modal-transition">
      <div class="modal-header is-stayinfo">
        <div class="heading-sub-sm">
          <div style="letter-spacing: -0.7px;" v-html="getWaitSubMent1"></div>
          <button
            v-if="getIsViewCbt"
            class="modal-btn-menu"
            @click="clickBtnCHATBOT()"
          >
            <div class="text">챗봇∙채팅상담 연결</div>
            <div class="icon icons-right"></div>
          </button>
          <div
            style="letter-spacing: -0.7px;"
            v-if="isAliveERS"
            v-html="getWaitSubMent2"
          ></div>
        </div>
      </div>
      <div class="modal-body">
        <div class="modal-content">
          <div class="msg-text">
            <div class="msg-waiting" v-if="isAliveERS">
              <div class="waiting-p" v-html="getWaitCount"></div>
              <div class="waiting-t" v-html="getWaitTime"></div>
            </div>
            <p class="text-left">
              현재 코로나 19 바이러스 감염 예방을 위해
              <br />
              전 상담원 마스크 착용으로 통화상태가
              <br />
              원활하지 않을 수 있으니 이점 양해 부탁드립니다.
              <br />
              <br />
              정확한 상담을 위해 본인이 아닌 경우에는
              <br />
              상담에 제한이 있을 수 있습니다.
              <br />
              <br />
              산업안전보건법에 따라
              <br />
              고객응대 근로자 보호조치가 시행중입니다.
              <br />
              상담원을 배려하는 마음으로 통화 부탁드립니다.
              <br />
              보다 나은 서비스 제공을 위하여
              <br />
              상담 내용은 녹음됩니다.
            </p>
          </div>
        </div>
      </div>
      <div class="modal-footer col-2">
        <button
          type=""
          class="btn btn-default modal-toggle"
          @click="clickCancleButton"
        >
          취소
        </button>
        <button
          type=""
          class="btn btn-primary modal-toggle"
          @click="clickOkButton"
        >
          확인
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["count", "wating", "skl_cd"],
  beforeCreate() {
    // store에 저장되어 있는 ERS 통신가능 여부를 조회해 온다. beforeCreate 훅에서 data() 의 isAliveERS 사용 불가능
    let _isAliveERS = this.$store.getters["system/getIsAliveERS"];
    console.log("ERS 통신 가능? :", _isAliveERS);

    // ERS로 통신 가능할때만 수행
    if (_isAliveERS) {
      // 실시간 조회하는 설정값들 초기화
      this.$store.commit("system/setErsSetCbtYn", "N");
      this.$store.commit("system/setOpenCbtYn", "N");

      /* ERS에 설정된 챗봇서비스 노출 여부 */
      this.reqErsSetCbtYn();

      /* 챗봇 서비스가 가능한지 체크 */
      this.reqOpenCbtYn();
    }
  },
  data() {
    return {
      pgmObj: this.getProgramData(),
      svcCode: this.$Util.getStore("CONN_SVC_CD"), // 서비스 화면코드
      cbtPrtYn: this.$Util.getStore("CBT_PRT_YN"), // 챗봇출력여부
      chatSprtBizYn: this.$Util.getStore("CHAT_SPRT_BIZ_YN"), // 채팅지원사업여부
      //isAliveERS: this.$Util.getStore("IS_ALIVE_ERS") // ERS통신 가능 여부
      isAliveERS: this.$store.getters["system/getIsAliveERS"] // ERS통신 가능 여부
    };
  },
  computed: {
    getWaitCount() {
      let retVal = "<small>현재 대기인원</small>\n";
      if (this.count < 100) {
        retVal += "<em>" + this.count + "</em>명";
      } else {
        retVal += "<em>100</em>명 이상";
      }
      return retVal;
    },
    getWaitTime() {
      let secCnt = Math.floor(this.wating / 30);
      let secVal = 0;

      if (this.wating % 30 > 0) secCnt += 1;
      secVal = secCnt * 30;

      let wMin = Math.floor(secVal / 60);
      let wSec = secVal % 60;

      let retVal = "<small>예상 대기시간</small>\n";
      // 대기시간이 30분 이상일때는 무조건 30분 이상으로 표기(2022.02.16 이인규D 요청)
      if (wMin < 30) {
        if (wMin > 0) {
          retVal += "<em>" + wMin + "</em>";
          retVal += "분";
        }
        retVal += "<em>" + wSec + "</em>";
        retVal += "초";
      } else {
        retVal += "<em>30</em>분 이상";
      }

      return retVal;
    },
    getWaitSubMent1() {
      let retVal = "지금은 모든 상담원이 통화중입니다.";
      if (!this.isAliveERS) {
        return retVal;
      }

      if (this.count < 1) {
        retVal =
          "실제 상담원 통화연결 시점의 대기인원 및 시간이<BR />다를 수 있으니, 이용에 참고하시기 바랍니다.";
      } else if (this.count > 0 && this.count < 99) {
        retVal =
          "지금은 모든 상담원이 통화중입니다.<BR />실제 상담원 통화연결 시점의 대기인원 및 시간이<BR />다를 수 있으니, 이용에 참고하시기 바랍니다.";

        if (this.getIsViewCbt) {
          retVal =
            "지금은 모든 상담원이 통화중입니다.<BR />통화료 부담없이 보다 빠른 상담을 원하시면 <BR />챗봇∙채팅상담을 이용해 주세요.";
        }
      } else {
        retVal =
          "지금은 통화량이 많아 상담원 연결이 어렵습니다.<BR />실제 상담원 통화연결 시점의 대기인원 및 시간이<BR />다를 수 있으니, 이용에 참고하시기 바랍니다.";

        if (this.getIsViewCbt) {
          retVal =
            "지금은 통화량이 많아 상담원 연결이 어렵습니다.<BR />통화료 부담없이 보다 빠른 상담을 원하시면<BR />챗봇∙채팅상담을 이용해 주세요.";
        }
      }

      return retVal;
    },
    getWaitSubMent2() {
      let retVal = "";

      // 챗봇∙채팅상담 버튼 아래 출력되어질 멘트. 대기 인원인 1 이상이고 챗봇서비스 오픈, ERS 셋팅값 "Y", DIVR 셋팅값 "Y"
      if (this.count > 0 && this.getIsViewCbt) {
        retVal =
          "실제 상담원 통화연결 시점의 대기인원 및 시간이<BR />다를 수 있으니, 이용에 참고하시기 바랍니다.";
      }

      return retVal;
    },
    ...mapState("system", {
      getIsViewCbt(state) {
        // 대기인원이 0 보다 클때, 챗봇서비스가 오픈 되었을때("Y"), ERS셋팅값이 설정되었을때("Y"), DIVR에 셋팅값이 노출일때("Y")
        let isOpenCbt = state.openCbtYn;
        let ersSetCbtYn = state.ersSetCbtYn;
        let cbtPrtYn = this.pgmObj.cbt_prt_yn;

        // 이용자 확인화면(비이용자)일 경우 이전화면 pgm_id, cbtPrtYn(챗봇출력여부)를 바라본다.
        let pgm_id = this.pgmObj.pgm_id;
        if (pgm_id == "VARS00500" || pgm_id == "VARS00600") {
          pgm_id = this.svcCode;
          cbtPrtYn = this.cbtPrtYn;
        }

        // 학습특별지원금은 openEpYn 나머지는 openCbtYn 을 바라본다.
        if (
          pgm_id == "VARS11000" || // 교육급여 학습 특별지원금
          pgm_id == "VARS11100" || // 지원금 기준 및 신청(자주하는질문)
          pgm_id == "VARS11101" || // 지원금 지급(자주하는질문)
          pgm_id == "VARS11102" // 지원금 사용방법(자주하는질문)
        ) {
          isOpenCbt = state.openEpYn;
        }

        return (
          this.count > 0 &&
          isOpenCbt == "Y" &&
          ersSetCbtYn == "Y" &&
          cbtPrtYn == "Y"
        );
      }
    })
  },
  methods: {
    clickOkButton() {
      this.$emit("close", this.skl_cd);
    },
    clickCancleButton() {
      this.$emit("close");
    },
    clickBtnCHATBOT() {
      let content =
        "선택하신 메뉴는 보이는 ARS 서비스 종료 후,<BR />챗봇·채팅 상담 화면으로 연결됩니다.<BR />계속하시겠습니까?";

      let pgm_id = this.pgmObj.pgm_id;
      let chatSprtBizYn = this.pgmObj.chat_sprt_biz_yn;

      // 이용자 확인화면(비이용자)일 경우 이전화면 pgm_id, chatSprtBizYn(채팅지원사업여부)를 바라본다.
      if (pgm_id == "VARS00500" || pgm_id == "VARS00600") {
        pgm_id = this.svcCode;
        chatSprtBizYn = this.chatSprtBizYn;
      }

      // 채팅상담지원사업이 아니면 문구를 바꾸어 준다.
      if (chatSprtBizYn == "N") {
        content =
          "해당 메뉴는 <span style='font-weight:bold'>챗봇 상담만</span> 가능합니다.<BR />연결을 원하시면 [확인] 버튼을<BR /> 눌러주세요.";
      }

      let url = process.env.VUE_APP_CHATBOT_APPURL;

      // 교육급여 학습특별지원금만 챗봇 URL이 다르다.
      if (
        pgm_id == "VARS11000" || // 교육급여 학습 특별지원금
        pgm_id == "VARS11100" || // 지원금 기준 및 신청(자주하는질문)
        pgm_id == "VARS11101" || // 지원금 지급(자주하는질문)
        pgm_id == "VARS11102" // 지원금 사용방법(자주하는질문)
      ) {
        url = process.env.VUE_APP_CHATBOT_EDU_APPURL;
      } else {
        content +=
          "<BR /><BR /><span style='font-weight:bold'>※ 재단 모바일앱 미설치된 경우,<BR />앱다운로드 및 설치 화면으로 연결</span>";
      }

      this.$alert({
        contents: content,
        align: "center",
        btn_type: this.$CONST.BTN_TP_OKCANCEL
      })
        .then(result => {
          this.log_debug(result);
          if (result == this.$CONST.BTN_KND_OK) {
            this.reqERSLink("CBT"); //여정관리 데이터 등록
            this.closeService(true, {
              url: url
            });
          }
        })
        .catch(function(err) {
          this.log_error(err);
        });
    }
  }
};
</script>
